import { PIMFormikSelect } from './PIMFormikSelect';

export default PIMFormikSelect;
